"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComposedPlaceholder = exports.isPlaceholder = exports.isAnyPlaceholder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type-guard testing whether the provided object is an instance of {@link AnyPlaceholder}.
 * @public
 */
function isAnyPlaceholder(obj) {
    var guards = [isPlaceholder, isComposedPlaceholder];
    return guards.some(function (pred) { return pred(obj); });
}
exports.isAnyPlaceholder = isAnyPlaceholder;
/**
 * Type-guard testing whether the provided object is an instance of {@link IPlaceholder}.
 * @public
 */
function isPlaceholder(obj) {
    return !isEmpty_1.default(obj) && obj.type === "IPlaceholder";
}
exports.isPlaceholder = isPlaceholder;
/**
 * Type-guard testing whether the provided object is an instance of {@link IComposedPlaceholder}.
 * @public
 */
function isComposedPlaceholder(obj) {
    return (!isEmpty_1.default(obj) &&
        obj.type === "IComposedPlaceholder");
}
exports.isComposedPlaceholder = isComposedPlaceholder;
//# sourceMappingURL=base.js.map